import React, { useState } from 'react';
import { Container, Form, Button, Alert, Card, Row, Col, Toast, ToastContainer } from 'react-bootstrap';

export default function Contact(){
  const [form, setForm] = useState({name:'', email:'', phone:'', message:''});
  const [sent, setSent] = useState(false);
  const [showToast, setShowToast] = useState(false);

  function handleChange(e){
    const {name, value} = e.target;
    setForm(f => ({...f, [name]: value}));
  }

  async function handleSubmit(e){
    e.preventDefault();
    // Simple client-side validation: require name, message, and either email or phone
    if(!form.name || !form.message || (!form.email && !form.phone)){
      alert('Please provide your name, a message, and at least an email or phone number.');
      return;
    }

    const apiEndpoint = 'https://us-central1-nbfserver-9cac0.cloudfunctions.net/api/contact';

    // POST to API endpoint as JSON
    try{
      setShowToast(true);
      const payload = {
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
        source: 'website'
      };
      console.log('Submitting contact form', form);
      const res = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if(!res.ok){
        throw new Error(data.error || `Send failed: ${res.status}`);
      }
      setSent(true);
      setForm({name:'', email:'', phone:'', message:''});
      setTimeout(() => setShowToast(false), 2000);
    }catch(err){
      console.error('Contact API error', err);
      alert('Sorry — we could not send your message. Please try again.');
      setShowToast(false);
    }
  }

  return (
    <Container className="px-1" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ color: '#1a3a44', borderRadius: '0', padding: '1.5rem 2rem 2rem', zIndex: 3, fontFamily: "'Nyoetes', 'Sora', 'Space Grotesk', 'Poppins', 'Segoe UI', sans-serif" }}>
      {/* Toast Notification */}
      <ToastContainer position="top-end" className="p-3">
        <Toast show={showToast} bg="success" delay={2000} autohide>
          <Toast.Header closeButton>
            <strong className="me-auto">✅ Sending</strong>
          </Toast.Header>
          <Toast.Body>Your message is being sent. Please wait...</Toast.Body>
        </Toast>
      </ToastContainer>
      <div className="text-center mb-4">
        <h2 className="fw-bold mb-3" style={{ fontSize: '3.425rem', color: '#c53607f5' }}>Contact Us</h2>
        <p className="fs-5" style={{ color: '#1a3a44' }}>Have a question or need prayer? Send us a message and we'll get back to you soon.</p>
      </div>
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={8}>
          <Card className="h-100" style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)', display: 'flex', flexDirection: 'column', border: '4px solid rgba(255,255,255,0.2)', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
            <Card.Body className="p-3 p-md-4">

              {sent && (
                <Alert variant="success" className="mb-2 border-start border-4" style={{ borderLeftColor: '#198754' }} dismissible>
                  ✅ Thanks — your message was sent.
                </Alert>
              )}
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold mb-1" style={{ color: '#1a3a44', fontSize: '1.1rem' }}>Your Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Raj Kumar"
                    required
                    size="sm"
                    style={{ borderColor: '#0d6efd', boxShadow: '0 0 0 0.2rem rgba(13, 110, 253, 0.15)' }}
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold mb-1" style={{ color: '#1a3a44', fontSize: '1.1rem' }}>Email <span className="text-muted">(or provide phone)</span></Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="raj@example.com"
                    size="sm"
                    style={{ borderColor: '#198754', boxShadow: '0 0 0 0.2rem rgba(25, 135, 84, 0.15)' }}
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold mb-1" style={{ color: '#1a3a44', fontSize: '1.1rem' }}>Phone <span className="text-muted">(optional if email provided)</span></Form.Label>
                  <Form.Control
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    size="sm"
                    style={{ borderColor: '#0dcaf0', boxShadow: '0 0 0 0.2rem rgba(13, 202, 240, 0.15)' }}
                  />
                </Form.Group>

                <Form.Group className="mb-2">
                  <Form.Label className="fw-semibold mb-1" style={{ color: '#1a3a44', fontSize: '1.1rem' }}>Message <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    placeholder="I need prayer for my family..."
                    required
                    style={{ borderColor: '#ffc107', boxShadow: '0 0 0 0.2rem rgba(255, 193, 7, 0.15)', fontSize: '1.05rem' }}
                  />
                </Form.Group>

                <Button 
                  type="submit" 
                  size="sm"
                  className="w-100 fw-bold d-flex align-items-center justify-content-center gap-2"
                  style={{ background: 'linear-gradient(180deg, rgba(250, 163, 150, 0.95), #c53607f5)', border: 'none' }}
                >
                  📧 Send Message
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      </div>
    </Container>
  );
}
